import { Chip } from '@mui/material';
import { get } from 'lodash';
import { useRecordContext } from 'react-admin';

export interface PerformanceChipFieldProps {
  source?: string;
  label?: string;
  'data-testid'?: string;
}

export const PerformanceChipField = ({ source = 'performance' }: PerformanceChipFieldProps) => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const value = get(record, source) as number | null | undefined;

  if (value === null || value === undefined) {
    return null;
  }

  const isZero = value === 0;
  const isPositive = value > 0;
  const formattedValue = `${isPositive ? '+' : ''}${value.toFixed(2)}%`;

  let buttonStyle;
  if (isZero) {
    buttonStyle = {
      backgroundColor: 'rgba(158, 158, 158, 0.15)',
      color: 'rgb(97, 97, 97)',
    };
  } else if (isPositive) {
    buttonStyle = {
      backgroundColor: 'rgba(76, 175, 80, 0.15)',
      color: 'rgb(46, 125, 50)',
    };
  } else {
    buttonStyle = {
      backgroundColor: 'rgba(244, 67, 54, 0.15)',
      color: 'rgb(198, 40, 40)',
    };
  }

  return (
    <Chip
      label={formattedValue}
      sx={{
        ...buttonStyle,
        fontWeight: 500,
        borderRadius: '12px',
        height: '32px',
      }}
    />
  );
};
